import log from 'salvo-lite/log'

class VideoAccordion {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._header = this._elem.querySelector('[data-video-accordion-header]')
        this._hiddenVideos = this._elem.querySelectorAll('[data-hidden-video]')
        this._expanded = this._elem.hasAttribute('data-expanded')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')

        if (this._expanded) {
            for (let hiddenVideo of this._hiddenVideos) {
                hiddenVideo.style.height = `${hiddenVideo.scrollHeight}px`
                hiddenVideo.classList.add('shown')
            }
        }

        this._header.addEventListener('click', (e) => {
            if (this._expanded) {
                this._elem.classList.remove('expanded')
                for (let hiddenVideo of this._hiddenVideos) {
                    hiddenVideo.style.height = `0px`
                    hiddenVideo.classList.remove('shown')
                }
            } else {
                this._elem.classList.add('expanded')
                for (let hiddenVideo of this._hiddenVideos) {
                    hiddenVideo.style.height = `${hiddenVideo.scrollHeight}px`
                    hiddenVideo.classList.add('shown')
                }
            }
            this._expanded = !this._expanded
        })
        log.debug(this.constructor.name, 'Initiated')
    }
}

export default VideoAccordion



// WEBPACK FOOTER //
// ./src/scripts/components/VideoAccordion.js